import React, { useState } from "react";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { MenuOutlined, SearchOutlined } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { colors } from "../theme/theme";
import { CustomBtn } from "../components/Common/CustomBtn";

const navItems = [
  { id: 1, title: "Home", route: "/home" },
  { id: 2, title: "Posts", route: "/posts" },
  { id: 3, title: "Gallery", route: "/gallery" },
  { id: 4, title: "Documents", route: "/documents" },
  { id: 5, title: "About Me", route: "/about-me" },
];

const LandingHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const smScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const [navAnchor, setNavAnchor] = useState(null);

  const isActive = (route) => location.pathname.startsWith(route);

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1200,
        backgroundColor: "#000",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        px: { xs: 2, md: 4 },
        py: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1.5}
        sx={{ cursor: "pointer" }}
        onClick={() => navigate("/home")}
      >
        <img
          src={require("../assets/icons/logo_sm.png")}
          alt="logo"
          style={{ height: "32px" }}
        />
        {/* <Typography
          sx={{
            color: "#fff",
            fontFamily: "Mulish-Bold",
            fontSize: "16px",
            display: { xs: "none", sm: "block" },
          }}
        >
          Birds of Paradise
        </Typography> */}
      </Stack>

      {!smScreen && (
        <Stack direction="row" spacing={4}>
          {navItems.map((item) => (
            <Box
              key={item.id}
              onClick={() => navigate(item.route)}
              sx={{
                cursor: "pointer",
                pb: 0.5,
                borderBottom: isActive(item.route)
                  ? `2px solid ${colors.secondary}`
                  : "2px solid transparent",
              }}
            >
              <Typography
                sx={{
                  color: isActive(item.route) ? "#fff" : "rgba(255,255,255,0.6)",
                  fontFamily: isActive(item.route)
                    ? "Mulish-SemiBold"
                    : "Mulish-Regular",
                  fontSize: "15px",
                  "&:hover": { color: "#fff" },
                }}
              >
                {item.title}
              </Typography>
            </Box>
          ))}
        </Stack>
      )}

      <Stack direction="row" alignItems="center" spacing={1.5}>
        <IconButton>
          <SearchOutlined sx={{ color: "#fff" }} />
        </IconButton>
        {smScreen && (
          <IconButton onClick={(e) => setNavAnchor(e.currentTarget)}>
            <MenuOutlined sx={{ color: "#fff" }} />
          </IconButton>
        )}
        <Menu
          anchorEl={navAnchor}
          open={Boolean(navAnchor)}
          onClose={() => setNavAnchor(null)}
        >
          {navItems.map((item) => (
            <MenuItem
              key={item.id}
              selected={isActive(item.route)}
              onClick={() => {
                navigate(item.route);
                setNavAnchor(null);
              }}
              sx={{ fontFamily: "Mulish-SemiBold", fontSize: "14px" }}
            >
              {item.title}
            </MenuItem>
          ))}
        </Menu>
        <CustomBtn
          text="Sign In"
          width="110px"
          height="38px"
          fontSize="14px"
          onClick={() => navigate("/sign-in")}
        />
      </Stack>
    </Box>
  );
};

export default LandingHeader;
